
import { Button } from "@/components/ui/button";
import { Plan } from "./types";
import { formatPrice } from "./utils";
import { Tooltip } from "@/components/ui/tooltip";
import { TooltipContent, TooltipProvider, TooltipTrigger } from "@/components/ui/tooltip";
import { DiscountRibbon } from "./DiscountRibbon";
import { calculateDiscountedAmount } from "./priceUtils";

interface PlanCardProps {
  plan: Plan;
  onSubscribe: (plan: Plan) => void;
  subscribing: boolean;
  isDisabled?: boolean;
  disabledReason?: string;
  discount?: {
    discount_type: 'fixed' | 'percentage';
    discount_value: number;
  } | null;
}

export function PlanCard({ 
  plan, 
  onSubscribe, 
  subscribing, 
  isDisabled, 
  disabledReason,
  discount 
}: PlanCardProps) {
  const showDiscount = discount !== null && discount !== undefined;
  
  const card = (
    <div className={`border rounded-lg p-6 hover:shadow-lg transition-shadow ${isDisabled ? 'opacity-60' : ''} relative`}>
      {showDiscount && (
        <DiscountRibbon 
          discountType={discount!.discount_type} 
          discountValue={discount!.discount_value} 
        />
      )}
      <h3 className="text-xl font-bold mb-2">{plan.plan_name}</h3>
      <p className="text-2xl font-bold text-primary mb-2">
        {formatPrice(plan.price)}
      </p>
      <p className="text-gray-600 mb-4">
        Duration: {plan.duration} {plan.duration === 1 ? 'day' : 'days'}
      </p>
      <div className="flex justify-center w-full">
        <Button
          className="rounded-md py-3 w-full"
          onClick={() => onSubscribe(plan)}
          disabled={subscribing || isDisabled}
          style={{ backgroundColor: '#008169', color: 'white' }}
        >
          {isDisabled ? "Not Available" : subscribing ? "Processing..." : "Subscribe Now"}
        </Button>
      </div>
    </div>
  );

  if (isDisabled && disabledReason) {
    return (
      <TooltipProvider>
        <Tooltip>
          <TooltipTrigger asChild>
            {card}
          </TooltipTrigger>
          <TooltipContent>
            <p>{disabledReason}</p>
          </TooltipContent>
        </Tooltip>
      </TooltipProvider>
    );
  }

  return card;
}
